export default __webpack_public_path__ + "static/media/silver.b2a59c76.png";